"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _themeContext = _interopRequireDefault(require("../theme/theme-context"));

const useTheme = () => _react.default.useContext(_themeContext.default);

var _default = useTheme;
exports.default = _default;
module.exports = exports.default;